module.exports = __webpack_public_path__ + "static/img/logo.4912d2c8.png";